var _path, _linearGradient, _path2, _path3, _path4, _path5, _linearGradient2, _rect, _path6, _path7, _linearGradient3, _polygon, _linearGradient4, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Support(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#727d86",
    d: "M39,44H24v-2h15c0.552,0,1-0.448,1-1v-9h2v9C42,42.654,40.654,44,39,44z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bPrihwi2wB0Nv6kKpoP0na",
    x1: 9.035,
    x2: 38.965,
    y1: 10.5,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bPrihwi2wB0Nv6kKpoP0na)",
    d: "M24,6C12,6,9.035,15,9.035,15h0.344c1.32,0,2.554-0.564,3.501-1.482 C15.76,10.725,19.68,9,24,9s8.24,1.725,11.12,4.518C36.067,14.436,37.302,15,38.621,15h0.344C38.965,15,36,6,24,6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#727d86",
    d: "M8,29v-7c0-8.822,7.178-16,16-16s16,7.178,16,16v7h2c0-3.729,0-5.783,0-7c0-9.941-8.059-18-18-18 S6,12.059,6,22c0,1.217,0,3.271,0,7H8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c6369",
    d: "M40,26l1.414,1.414C41.789,27.789,42,28.298,42,28.828v7.343c0,0.53-0.211,1.039-0.586,1.414L40,39 V26z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#727d86",
    d: "M40,39h-5c-1.105,0-2-0.895-2-2v-9c0-1.105,0.895-2,2-2h5V39z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bPrihwi2wB0Nv6kKpoP0nb",
    x1: 35.25,
    x2: 42.75,
    y1: 28.75,
    y2: 36.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33bef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a85d9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 13,
    x: 38,
    y: 26,
    fill: "url(#bPrihwi2wB0Nv6kKpoP0nb)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c6369",
    d: "M8,26l-1.414,1.414C6.211,27.789,6,28.298,6,28.828v7.343c0,0.53,0.211,1.039,0.586,1.414L8,39V26z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#727d86",
    d: "M8,39h5c1.105,0,2-0.895,2-2v-9c0-1.105-0.895-2-2-2H8V39z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bPrihwi2wB0Nv6kKpoP0nc",
    x1: 62.25,
    x2: 69.75,
    y1: 28.75,
    y2: 36.25,
    gradientTransform: "matrix(-1 0 0 1 75 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33bef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a85d9"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bPrihwi2wB0Nv6kKpoP0nc)",
    points: "8,26 10,26 10,39 8,39"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bPrihwi2wB0Nv6kKpoP0nd",
    x1: 21.879,
    x2: 26.121,
    y1: 40.879,
    y2: 45.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33bef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a85d9"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bPrihwi2wB0Nv6kKpoP0nd)",
    d: "M27,43c0,1.657-1.343,3-3,3s-3-1.343-3-3s1.343-3,3-3S27,41.343,27,43z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Support);
export default __webpack_public_path__ + "static/media/icons8-support.45e9cb0fcb4fca96c619e64eb26edd3d.svg";
export { ForwardRef as ReactComponent };